import styled from "styled-components";
import { FLEX } from "styles/flex";
import { COLORS, DARK_THEME_COLORS, LIGHT_THEME_COLORS } from "styles/colors";
import Status from "components/atoms/text/labels/Status";
import { Text } from "components/atoms/text/Text";
import Cloud from "components/atoms/text/labels/Cloud";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { checkEmpty } from "utils/functions";

export interface TableTitleRow {
  status: string;
  cloudSystemId?: string;
  type: string;
  title: string;
  recorderCount?: number;
  mergedSystemId?: string;
  version: string;
  onlineStatue?: boolean;
}

type TableTitleProps = {
  report?: boolean;
  row: TableTitleRow;
  onCellClick?: () => void;
  cloudStatus?: boolean;
};

function TableTitle({
  report,
  row,
  onCellClick,
  cloudStatus = true,
}: TableTitleProps): JSX.Element {
  const location = useLocation();
  const theme = useAppSelector((state) => state.theme.theme);
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  return (
    <TitleContainer
      onClick={onCellClick}
      className="recorder-title"
      data-testid="blocks-table-table-title-container-cell"
    >
      <TitleWrapper>
        <NameLabel>
          {selectedAccount.isEnabled && (
            <>
              <Status
                status={
                  typeof row.onlineStatue === "boolean"
                    ? row.onlineStatue
                      ? "online"
                      : "offline"
                    : row.onlineStatue ?? row.status
                }
              />

              {!checkEmpty(row.cloudSystemId) &&
                (row.type === "Spectrum" || row.type === "SPECTRUM") && (
                  <Cloud
                    style={cloudStatus ? {} : { color: COLORS.BUTTONS1 }}
                  />
                )}
            </>
          )}

          <Text className="title" fontSize={14}>
            {row.title}
          </Text>
        </NameLabel>
      </TitleWrapper>
      {row.recorderCount !== undefined &&
        row.recorderCount > 1 &&
        !location.pathname.includes("/billing/recorders") && (
          <Text
            className="recorder-title-bottom-info"
            id="recorder-count"
            color={
              theme === "light"
                ? LIGHT_THEME_COLORS.STATUS
                : DARK_THEME_COLORS.STATUS
            }
            fontSize={14}
          >
            [{row.recorderCount} Servers Merged]
          </Text>
        )}
    </TitleContainer>
  );
}
const TitleContainer = styled.div`
  width: 100%;
  max-width: 500px;
`;

const TitleWrapper = styled.div`
  ${FLEX.FlexBetweenCenter};
  width: 100%;
  flex: 1;
  .title {
    white-space: normal;
    word-break: break-all;
    line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-word;
    white-space: normal;
  }

  #recorder-count {
    flex: 0 0 auto;
  }
`;

const NameLabel = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 5px;
  width: 100%;
  flex: 1 1 auto;
  min-height: 24px;
  min-width: 120px;
  img {
    width: 14px;
  }

  .title {
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1 1 auto;
    width: 100%;
  }
`;

export default TableTitle;
